
import { useEffect, useState, useRef } from "react";
import { useLayoutEffect } from "react"; // TODO: EXPERIMENTING

import { useUserUpdate } from "../context/UserContext";

import { LoginMethod } from "@Beasted1010/pivotal-wisdom";

import { fetchAuthCredentials } from "../utilities/server-fetch";

import { FeatureComingSoon } from "../common/Components";

import { GoogleLogin } from "@react-oauth/google";
import FacebookLogin from "@greatsumini/react-facebook-login";


export {
  useGoogleAuth, useFacebookAuth,
  logUserOut
};


/* =========================== Data Definitions ============================= */
//const CLIENT_ID = "899776048776-mbb9i97hanflc2mu6j4h85c2bi9b490o.apps.googleusercontent.com";
const CLIENT_ID = "554576131061-aldegv7staqa8h045r7fjdo7es7cap4c.apps.googleusercontent.com";


/* =========================== Hooks ============================= */


/* =============================================================== */
/* =========================== GOOGLE =========================== */
/* =============================================================== */
/*
function useGoogleAuth() {
  const handleGoogleCredentialResponse = useGoogleCredentialResponseHandler();
  //const CLIENT_ID = "YOUR_CLIENT_ID.apps.googleusercontent.com"; // Replace with your actual client ID

  const GoogleAuth = () => {
    const buttonRef = useRef(null);

    useEffect(() => {
      // Function to load the Google Sign-In script
      const loadGoogleSignInScript = (src: string) => {
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.onload = () => resolve(script);
          script.onerror = () => reject('Failed to load script');
          document.body.appendChild(script);
        });
      };

      const initGoogleSignInButton = () => {
        (window as any).gapi.signin2.render(buttonRef.current, {
          scope: 'profile email',
          width: 240,
          height: 50,
          longtitle: true,
          theme: 'dark',
          onsuccess: handleGoogleCredentialResponse,
          onfailure: (error: any) => console.error('Google Sign-In failure:', error)
        });
      };

      loadGoogleSignInScript("https://apis.google.com/js/platform.js")
        .then(() => {
          (window as any).gapi.load('auth2', () => {
            (window as any).gapi.auth2.init({ client_id: CLIENT_ID });
          });
          (window as any).gapi.load('signin2', initGoogleSignInButton);
        })
        .catch(console.error);

      return () => {
        // Cleanup
        const scriptTag = document.querySelector('script[src="https://apis.google.com/js/platform.js"]');
        //if (scriptTag) document.body.removeChild(scriptTag);
      };
    }, []);

    return (
      <button className="google-login-button">
        <div ref={buttonRef}></div>
      </button>
    );
  };

  return { GoogleAuth };
}
*/

function useGoogleAuth() {

  const handleGoogleCredentialResponse = useGoogleCredentialResponseHandler();

  const GoogleAuth = () => {
    // Leveraging @react-oauth/google: https://www.npmjs.com/package/@react-oauth/google

    return (
      <>
        <button className="google-login-button">
          <GoogleLogin
            onSuccess={ credentialResponse => {
              handleGoogleCredentialResponse( credentialResponse );
            }}
            onError={ () => {
              console.error("Login Failed (Google)");
            }}

            type="standard"
            size="large"
            width="250"
            theme="filled_blue"
            text="continue_with"
            shape="rectangular"
            logo_alignment="left"
          />
        </button>
      </>
    );
  };

  return { GoogleAuth };
}

/*
function useGoogleAuth() {


  // TODO:
  //THOUGHT: I implement my own GoogleOAuthProvider-like Context Provider
  // That will house essentially all the code below, except I expose it via some useGoogleOAuth method  (provided via Context)
  // Then, I can simply use that method to get the Google Sign-In Button itself, 
  // ... and then place it in desired spot by using it here and placing that button in the return (i.e. where <div> is currently, just now it won't have the Ref on it, since that's down in the Context Provider's Method)

  const handleGoogleCredentialResponse = useGoogleCredentialResponseHandler();

  const GoogleAuth = () => {
    const src = "https://accounts.google.com/gsi/client";
    const buttonRef = useRef<any>( null );

    const initializeButton = () => {

      if( buttonRef.current ) {
        buttonRef.current.setAttribute("class", "g_id_signin"); // Required Class
        buttonRef.current.setAttribute("id", "g_id_onload"); // Required ID
        buttonRef.current.setAttribute("data-client_id", CLIENT_ID);
        buttonRef.current.setAttribute("data-type", "standard");
        buttonRef.current.setAttribute("data-size", "large");
        buttonRef.current.setAttribute("data-width", "250");
        buttonRef.current.setAttribute("data-theme", "filled_blue");
        buttonRef.current.setAttribute("data-text", "continue_with");
        buttonRef.current.setAttribute("data-shape", "rectangular");
        buttonRef.current.setAttribute("data-logo_alignment", "left");
        buttonRef.current.setAttribute("data-callback", "handleGoogleCredentialResponse");
        window.handleGoogleCredentialResponse = handleGoogleCredentialResponse; // Need public for ^ to work
        console.log("!!! BUTTON REF UPDATED !!!");

        //if (window.gapi && window.gapi.signin2 && window.gapi.signin2.render) {
          //(window as any).gapi.signin2.render('g_id_onload');
        //}
      }
      else { console.log("BUTTON REF CURRENT IS NULL... ", buttonRef); }

    };

    useEffect( () => {
      loadScript( src ).then( () => {
        console.log("INITILAIZED FROM LOAD SCRIPT CALLBACK");
        initializeButton();
      }).catch( console.error ); // TODO: Error Handle

      // Cleanup Function
      return () => {
        const scriptTag = document.querySelector( `script[src="${src}"]` );
        if( scriptTag ) { document.body.removeChild( scriptTag ); console.log("SCIRPT REMOVED"); }
      };

    }, [buttonRef] );

    return (
      <button className="google-login-button">
        <p> HI THERE LOADING </p>
        <div ref={buttonRef}></div>
      </button>
    );
  }

  return { GoogleAuth };
}
*/


/*
window.onload = () => {
    const initializeButton = () => {

      if( buttonRef.current ) {
        buttonRef.current.setAttribute("class", "g_id_signin"); // Required Class
        buttonRef.current.setAttribute("id", "g_id_onload"); // Required ID
        buttonRef.current.setAttribute("data-client_id", CLIENT_ID);
        buttonRef.current.setAttribute("data-type", "standard");
        buttonRef.current.setAttribute("data-size", "large");
        buttonRef.current.setAttribute("data-width", "250");
        buttonRef.current.setAttribute("data-theme", "filled_blue");
        buttonRef.current.setAttribute("data-text", "continue_with");
        buttonRef.current.setAttribute("data-shape", "rectangular");
        buttonRef.current.setAttribute("data-logo_alignment", "left");
        buttonRef.current.setAttribute("data-callback", "handleGoogleCredentialResponse");
        window.handleGoogleCredentialResponse = handleGoogleCredentialResponse; // Need public for ^ to work
        console.log("!!! BUTTON REF UPDATED !!!");

        //if (window.gapi && window.gapi.signin2 && window.gapi.signin2.render) {
          (window as any).gapi.signin2.render('g_id_onload');
        //}
      }
      else { console.log("BUTTON REF CURRENT IS NULL... ", buttonRef); }

    };

        loadScript( src ).then( () => {
          console.log("INITILAIZED FROM LOAD SCRIPT CALLBACK");
          initializeButton();
        }).catch( console.error ); // TODO: Error Handle

      // Cleanup Function
      return () => {
        const scriptTag = document.querySelector( `script[src="${src}"]` );
        if( scriptTag ) { document.body.removeChild( scriptTag ); console.log("SCIRPT REMOVED"); }
      };

    }, [] );
};
*/












// Used to separate from useGoogleAuth Hook, to keep that clean
function useGoogleCredentialResponseHandler() {

  const { updateUser } = useUserUpdate();

  const handleGoogleCredentialResponse = ( response: any ) => {

    const responsePayload = parseJwt(response.credential); // Decode Credential Response
    //console.log( responsePayload );

    /* TID BITS FROM QUALITY SOURCES
    - Save Credential Object in my DB after every API Request to get Creds (to ensure got latest)
    - After VERIFIED TOKEN, check if User already in my User DB
    -- Yes? Establish an Authenticated Session for User
    -- No? Create new User Record from Info in the ID Token Payload AND establish Session for User
    --- Can Prompt User for any additional Profile Info you Require for your App
    */

    // USE "sub(ject)" as User ID to store Info, NOT Email (as that can change later)
    /*
    console.log("ID: " + responsePayload.sub);
    console.log('Full Name: ' + responsePayload.name);
    console.log('Given Name: ' + responsePayload.given_name);
    console.log('Family Name: ' + responsePayload.family_name);
    console.log("Image URL: " + responsePayload.picture);
    console.log("Email: " + responsePayload.email);
    */

    const user: IUser = {
      externalId: responsePayload.sub,

      email: responsePayload.email,
      name: responsePayload.given_name,
      firstName: responsePayload.given_name,
      lastName: responsePayload.family_name,
      avatarURL: responsePayload.picture,

      loginMethod: LoginMethod.GOOGLE,
    };

    postToLoginEndpoint( user, updateUser );
  }

  return handleGoogleCredentialResponse;
}


/* =============================================================== */
/* =========================== FACEBOOK =========================== */
/* =============================================================== */

const useFacebookAuth = () => {

  const [appID, setAppID] = useState( null );

  const handleFacebookCredentialResponse = useFacebookCredentialResponseHandler();

  useEffect( () => {

    const fetchAppID = async () => {
      const credentials = await fetchAuthCredentials( LoginMethod.FACEBOOK );

      if( !credentials || !credentials.appID ) {
        console.error( "Facebook Auth Failed - No App ID Available" );
        return;
      }

      setAppID( credentials.appID );
    }

    fetchAppID();
  }, []);

  const FacebookAuth = () => {
    // Leveraging @greatsumini/react-facebook-login: https://www.npmjs.com/package/@greatsumini/react-facebook-login
    // See Facebook Apps for Config / Domains / Prod Setup: https://developers.facebook.com/apps/
    if( !appID ) return <p>Loading...</p>; // TODO: Consistent <Loading /> Component (perhaps have it as a Spinner)

    return (
      <>
        {/* TODO: Support Facebook Login -- disabled and FeatureComingSoon for now */}
        <button className="facebook-login-button" disabled >
          <FeatureComingSoon />
          <FacebookLogin
            appId={appID}

            initParams={{
              version: "v16.0"
            }}

            onSuccess={ (response: any) => {
              //console.log("(TOKEN) RESPONSE FROM FACEBOOK OAUTH: ", response);
            }}
            onFail={ (error: any) => {
              console.error( "Login Failed (Facebook)" );
              console.error( "ERROR: ", error );
            }}
            onProfileSuccess={ (response: any) => {
              console.log( "(PROFILE) Response from Facebook OAuth: ", response );
              handleFacebookCredentialResponse( response );
            }}

            fields="id, first_name, last_name, name, email, picture, short_name"

            style={{
              backgroundColor: '#4267b2',
              color: '#fff',
              fontSize: '16px',
              padding: '12px 24px',
              border: 'none',
              borderRadius: '4px',
            }}
          />
        </button>
      </>
    );
  };

  return { FacebookAuth };
}
function useFacebookCredentialResponseHandler() {

  const { updateUser } = useUserUpdate();

  const handleFacebookCredentialResponse = (response: any) => {
    // TODO: PROPER ERROR HANDLING THROUGHOUT (Proper UX when failed to login)

    if( !response ) {
      console.error("Did not receive Facebook credential response");
      return;
    }

    if( !response.id || !response.name || !response.email || !response.picture ) {
      console.error("Did not receive expected properties on Response. Got:", response);
      return;
    }

    const user: IUser = {
      externalId: response.id,
      email: response.email,
      name: response.short_name,
      firstName: response.first_name,
      lastName: response.last_name,
      avatarURL: response.picture.data.url, // TODO: VERIFY "picture" exists on FB Login (does for Google)
      loginMethod: LoginMethod.FACEBOOK,
    };
    postToLoginEndpoint( user, updateUser );
  };

  return handleFacebookCredentialResponse;
}



/*
// See Types Here:  https://github.com/DefinitelyTyped/DefinitelyTyped/blob/d5ef8a682292f92745675c384dc8f669ed4e843f/types/facebook-js-sdk/index.d.ts
//import "facebook-js-sdk"; // Import Types associated with it

// React FB Login Library Alternative: https://www.npmjs.com/package/react-facebook-login#basic-button-with-styling
const useFacebookAuth = () => {
  const buttonRef = useRef<any>( null );

  const statusChangeCallback = useFacebookStatusChange();

  const checkLoginState = () => {
    FB.getLoginStatus( function(response) {
      statusChangeCallback(response);
    });
  }

  const FacebookAuth = () => {
    useEffect( () => {
      // TODO: REMOVE HARD CODED APP ID AND MOVE TO CONSTANT VARIABLE
      const src = `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v15.0&appId=${819034822659220}&autoLogAppEvents=1`;

      loadScript( src ).then( () => {
        if( buttonRef == null || buttonRef.current == null ) {
          // TODO: Error HANDLE
          return;
        }

        // Generate Properties: https://developers.facebook.com/docs/facebook-login/web/login-button
        buttonRef.current.setAttribute("class", "fb-login-button"); // Required Class
        buttonRef.current.setAttribute("data-width", "250");
        buttonRef.current.setAttribute("data-size", "Large");
        buttonRef.current.setAttribute("data-button-type", "continue_with");
        buttonRef.current.setAttribute("data-layout", "default");
        buttonRef.current.setAttribute("data-auto-logout-link", "false");
        buttonRef.current.setAttribute("data-use-continue-as", "false");
        //buttonRef.current.setAttribute("data-scope", "email");
        buttonRef.current.setAttribute("data-onlogin", "checkLoginState();");
        //buttonRef.current.setAttribute("data-redirect-uri", "http://localhost:5000/login");
        window.checkLoginState = checkLoginState; // Need public for ^ to work

        //<div class="fb-login-button" data-width="250" data-size="large" data-button-type="continue_with" data-layout="default" data-auto-logout-link="false" data-use-continue-as="false"></div>


      }).catch( console.error ); // TODO: ERROR HANDLE

      // Cleanup Function
      return () => {
        const scriptTag = document.querySelector( `script[src="${src}"]` );
        //if( scriptTag ) document.body.removeChild( scriptTag );
      };

    }, [] );

    return (
      <button className="facebook-login-button">
        {// Has to be a div for fb-login-button Class (?) <button> NOT WORK}
        <div ref={buttonRef}></div>
      </button>
    );
  };

  return { FacebookAuth };
}
*/

function useFacebookStatusChange() {

  const { updateUser } = useUserUpdate();

  const statusChangeCallback = ( response: fb.StatusResponse ) => {
    if( response.status === "connected" ) {
      // Logged in to your App AND Facebook (if wanted to make FB API calls)
      const userParams = {
        fields: "id, first_name, last_name, name, email, picture, short_name"
      };

      FB.api("/me", userParams, function( userDetails: any ) { // Automatically adds FB Access Token to call
        //console.log( "FB API Response:" ); console.log( userDetails );

        if( !userDetails || userDetails.error ) {
          // TODO: HANDLE ERROR
          console.error( "ERROR:", userDetails.error );
        }

        const user: IUser = {
          externalId: userDetails.id,
          email: userDetails.email,
          name: userDetails.short_name,
          firstName: userDetails.first_name,
          lastName: userDetails.last_name,
          avatarURL: userDetails.picture, // TODO: VERIFY "picture" exists on FB Login (does for Google)
          loginMethod: LoginMethod.FACEBOOK,
        };
        postToLoginEndpoint( user, updateUser );
      });

    }
    else if( response.status === "not_authorized" ) {

    }
    else {
      // Person not logged in to your App or Facebook is unable to tell
      //console.log( "NOT LOGGED IN ??" );
    }
  };

  return statusChangeCallback;
}




/* =========================== HELPERS =========================== */
const loadScript = (src: string) => {
  return new Promise( (resolve: any, reject: any) => {
    if( document.querySelector(`script[src="${src}"]`) ) {
      return resolve();
    }

    const script = document.createElement( "script" );
    script.src = src;
    script.onload = () => resolve();
    script.onerror = err => reject( err );
    document.body.appendChild( script );
  });
}

// Source: https://stackoverflow.com/a/38552302/7318703
function parseJwt( token: string ) {
  var base64URL = token.split('.')[1];
  var base64 = base64URL.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}



// TODO: Decide where put... Or how structure or how do...
function logUserOut( user: IUser ) {
  //console.log( "LOGGING USER OUT..." );

  //const googleSignOutAPI = "https://apis.google.com/js/platform.js";
  //const src = "https://accounts.google.com/gsi/client";

  // TODO: Use User Object to determine logInMethod?
  switch( user.loginMethod ) {
    case LoginMethod.GOOGLE: // TODO: Make LogInMethodSelector ???
      //console.log( "Google Log Out COMPLETE" );
      //console.log( "NOTHING SPECIAL HERE" );

      break;

    case LoginMethod.FACEBOOK:

      break;

    default:
      console.error( "Invalid Login Method", user.loginMethod );
  }
  //disableAutoSelect

  postToLogoutEndpoint( user );
}


type UserSetterFunction = ( user: IUser ) => null;
async function postToLoginEndpoint( user: IUser, userSetter: UserSetterFunction ) {
  // TODO: ERROR HANDLE
  if( user.externalId == null ) {
    //console.log("EXTERNAL ID IS NULL"); console.log(user);
    return;
  }

  //const response = await fetch( "http://localhost:7777/login", {
  const response = await fetch( "/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(user),
    credentials: "include"
  });

  const responseJSON = await response.json();
  //console.log( "Login Response", responseJSON );

  if( responseJSON.success ) {
    //console.log( "Storing in LocalStorage" );
    //localStorage.setItem( "user", JSON.stringify(responseJSON.user) );
    userSetter( user );
  }
  else {
    console.error("FAILED TO LOGIN", responseJSON);
  }

  const modal = document.getElementById("log-in_modal");
  if( modal != null ) {
    modal.style.display = "none";
    document.body.style.overflow = "auto";
  }

  // TODO: HUGE HACK - Cuz can't refetch Feature data once log-in from Program Page via Locked Lesson Login Button -- Never seems trigger useEffect... -- Bashed head against wall for hours -- Going with this for now
  //window.location.reload();
}

async function postToLogoutEndpoint( user: IUser ) {
  // TODO: ERROR HANDLE
  if( user.externalId == null ) {
    //console.log("USER ID IS NULL", user);
    return;
  }

  //const response = await fetch( "http://localhost:7777/logout", {
  const response = await fetch( "/logout", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(user),
    credentials: "include"
  });
}












/* */
